import cs from "classnames";

import { Typography } from "@braintrust/braintrust-ui-components";
import { RouterLink } from "@js/components/link";

type OfferNotFoundProps = { reason: EnumType<typeof ENUMS.OfferStatus> };

import styles from "./styles.module.scss";

export const OfferNotFound = ({ reason }: OfferNotFoundProps) => {
  const message =
    reason === ENUMS.OfferStatus.CANCELLED
      ? "This offer is no longer available because either client decided to cancel his offer or talent canceled their bid."
      : "Sorry, we can't find this offer.";

  return (
    <>
      <Typography component="h1" variant="display">
        Uh oh!
      </Typography>
      <Typography
        component="p"
        variant="title"
        fontWeight={400}
        className={styles.message}
      >
        {message}{" "}
      </Typography>
      <Typography
        component="p"
        variant="title"
        size="medium"
        fontWeight={400}
        className={cs(styles.info, styles.noMaxWidth)}
      >
        <Typography component="p">
          Please reach out to us with any questions.
        </Typography>
        <Typography component="p" sx={{ mt: 1 }}>
          Return to the <RouterLink to="/">homepage</RouterLink>
        </Typography>
      </Typography>
    </>
  );
};
